import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class Background extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, numGlows: number) {
        
        super(scene);

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0x1e4fa3);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(background);

        let bgGlow: Phaser.GameObjects.Image;

        if (numGlows === 2) {

            const dy = 150;

            bgGlow = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 - dy * GameVars.scaleY, "bg_glow");
            bgGlow.setScale(1.95, 1.95 * GameVars.scaleY);
            this.add(bgGlow);
    
            bgGlow = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + dy * GameVars.scaleY, "bg_glow");
            bgGlow.setScale(1.95, 1.95 * GameVars.scaleY);
            this.add(bgGlow);

        } else {

            if (numGlows === 1) {
                bgGlow = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "bg_glow");
                bgGlow.setScale(1.95, 1.95 * GameVars.scaleY);
                this.add(bgGlow);
            }
           
            this.addStarTiles();
        }
    }

    public addStarTiles(alphaTween?: boolean): void {

        const starTilesContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(starTilesContainer);

        let x = 0;
        let y = 0;

        const n = Math.round(GameConstants.GAME_HEIGHT / 310 / GameVars.scaleY) + 1;

        for (let i = 0; i < n; i ++) {
           
            let pattern = new Phaser.GameObjects.Image(this.scene, x, y, "bg_texture");
            pattern.setOrigin(0);
            pattern.scaleY = GameVars.scaleY;
            starTilesContainer.add(pattern);

            x += 464;

            pattern = new Phaser.GameObjects.Image(this.scene, x, y, "bg_texture");
            pattern.setOrigin(0);
            pattern.scaleY = GameVars.scaleY;
            starTilesContainer.add(pattern);

            x = 0;
            y += 310 * GameVars.scaleY;
        }

        if (alphaTween) {
            
            starTilesContainer.alpha = 0;

            this.scene.add.tween({
                targets: starTilesContainer,
                alpha: 1,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 350
            });
        }
    }
}
